import ListPurchaseInvoices from "../../../../components/@documents/purchase_invoices/ListPurchaseInvoices";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function PurchaseInvoicesPage() {

    return (
        <ListPurchaseInvoices 
            routeType={routeTypes.admin}
        />
    )
}